export interface GradientProps {
  uuid: string
}

export const AiGradientDefs: React.FC<GradientProps> = ({ uuid }) => (
  <defs>
    <HorizontalGradient uuid={uuid}>
      <AiGradientStops />
    </HorizontalGradient>
  </defs>
)

const HorizontalGradient: React.FC<React.PropsWithChildren<GradientProps>> = ({
  uuid,
  children,
}) => (
  <linearGradient id={uuid} x1="0%" y1="50%" x2="100%" y2="50%" gradientUnits="userSpaceOnUse">
    {children}
  </linearGradient>
)

export const AiGradientStops: React.FC = () => (
  <>
    <stop stopColor="#399CD4" />
    <stop offset="1" stopColor="#5E5BE9" />
  </>
)
